import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'
import useModelsFingerprint from '@/services/api/model/useModelsFingerprint'

/**
 * GET team/cash-flow/forecast-score/month-to-date — the forecast score for the
 * elapsed part of the current calendar month.
 *
 * As-at-today, no period params, no vault filter. Fingerprinted like the other
 * dashboard feeds so toggling a What-If re-reads it.
 */
export default function useGetMonthToDateScore({ enabled = true } = {}) {
  const modelsFingerprint = useModelsFingerprint()

  const fetchData = async () => {
    const response = await httpClient.get(
      'team/cash-flow/forecast-score/month-to-date',
    )
    return response.data
  }

  return useQuery({
    queryKey: ['month-to-date-score', { modelsFingerprint }],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled,
  })
}
